const SvgIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    fill="none"
    viewBox="0 0 24 24"
  >
    <path
      stroke="#ECE5E5"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M5.25 18.75H1.5v-12h21v12h-3.75m0-12V1.5H5.25v5.25M16.5 10.5h2.25m-13.5 3.75v8.25h13.5v-8.25z"
    ></path>
  </svg>
);

export default SvgIcon;
